module.exports = __webpack_public_path__ + "static/media/ds-podium_01.7056a1cc.png";